(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("mars3d"), require("mars3d-cesium"));
	else if(typeof define === 'function' && define.amd)
		define("mars3dSupermap", ["mars3d", "mars3d-cesium"], factory);
	else if(typeof exports === 'object')
		exports["mars3dSupermap"] = factory(require("mars3d"), require("mars3d-cesium"));
	else
		root["mars3dSupermap"] = factory(root["mars3d"], root["Cesium"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__2__) {
return 